import { z } from 'zod';

export const TABLET_GROUP_COLLECTION = 'tabletGroups';

export const TabletGroupSchema = z.object({
  id: z.string().optional(),
  name: z.string().nonempty('Name is required').default(''),
  enabled: z.boolean().default(true),
});

export type TabletGroup = z.infer<typeof TabletGroupSchema>;
